<div matDialogTitle class="send-to-garmin__header">
  <h1 class="send-to-garmin__header__title" i18n="@@S_SENDTHISLOCTOVEHICLE">Send this location to a vehicle</h1>
  <button mat-icon-button matDialogClose class="send-to-garmin__header__close"><mat-icon>close</mat-icon></button>
</div>

<div matDialogContent class="send-to-garmin__content">
  <form class="send-to-garmin__content__form" [formGroup]="sendToGarminForm" novalidate>
    <mat-form-field floatLabel="always"
      ><mat-label i18n="@@S_VEHICLES">Vehicles</mat-label
      ><mat-select
        formControlName="vehicle"
        placeholder="Select an option"
        i18n-placeholder="@@S_SELECTANOPTION"
        [class.has-error]="vehicle.invalid && vehicle.touched"
        class="send-to-garmin-select"
      >
        <mat-option *ngFor="let vehicle of vehicleSelection$ | async" [value]="vehicle.vehicleId">{{ vehicle.label }}</mat-option>
      </mat-select>
      <mat-error *ngIf="vehicle.invalid && vehicle.touched" i18n="@@S_PLSSELECTVEHICLE">Please select a vehicle from the list</mat-error>
    </mat-form-field>

    <mat-form-field floatLabel="always"
      ><mat-label i18n="@@S_DESCRIPTION">Description</mat-label
      ><textarea matInput ngDefaultControl class="send-to-garmin-textarea" rows="5" formControlName="description"></textarea>
    </mat-form-field>
  </form>
</div>

<div matDialogActions class="send-to-garmin__actions">
  <button
    [disabled]="!sendToGarminForm.valid"
    mat-flat-button
    color="accent"
    id="btn-sendToGarmin"
    i18n="@@S_SENDTOGARMIN"
    componentStyle="primary"
    (click)="onSendClick()"
  >
    Send to a garmin
  </button>
</div>
